import React from "react"
import { Link } from "gatsby"
import { Container, StLogo } from "./Header.css"
import { LaboratorioDeContenidosDeMarca, Paula } from "copesa-logos"

const Header = ({ sponsorLogo}) => (
  <Container>
    <Link to="/" className="slotSite">
      <StLogo>
        <Paula />
      </StLogo>
    </Link>
    {
      sponsorLogo &&
      <Link to="/" className="slotSponsor">
        <StLogo className="slotSponsorLogo">
          <span>Auspiciado por</span>
          <img src={sponsorLogo} alt="" />
        </StLogo>
      </Link>
    }
    <a href="https://laboratoriodecontenidos.cl/" className="slotLab" target="_blank" rel="noopener noreferrer">
      <StLogo>
        <LaboratorioDeContenidosDeMarca />
      </StLogo>
    </a>
  </Container>
)


export default Header
